import { HelperWrapper } from '../helper-wrapper'
import { ModalWrapper } from '../modal-wrapper'
import { FormWrapper } from './form-wrapper.component'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  handleClose: () => void
  handleSelectItem: (id: string) => void
}

export const ManualAccountAddModal = ({ open, handleSelectItem, handleClose }: IProps) => {
  const classes = useStyles()

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.modalWrapper}>
      <h3 className={classes.title}>
        <HelperWrapper t="manual-account-modal-title" />
      </h3>
      <FormWrapper handleClose={handleClose} handleSelectItem={handleSelectItem} />
    </ModalWrapper>
  )
}
